import { render } from "./AtributoModal.vue?vue&type=template&id=564a3ae5"
import script from "./AtributoModal.vue?vue&type=script&lang=js"
export * from "./AtributoModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__